var cell_default = {
  "cell": "mXn-Q",
  "header": "_3yOsx",
  "selected": "_5aHFm",
  "editing": "xV4ce",
  "singleSelection": "_14GEk",
  "hideLastBlock": "MmVnq",
  "editorWrapper": "_6xPX4",
  "viewerWrapper": "_1Cxzn",
  "hideFirstBlock": "MvOs7",
  "editor": "zlqHJ",
  "edit": "eQfKX",
  "view": "gmir0",
  "editingToolbarWrapper": "DceJP",
  "selectAll": "yYOQq",
  "disableSelection": "-Qvum"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
